// extracted by mini-css-extract-plugin
export var statItem = "_l1-1";
export var statsRow = "_l1-0";